import { Container, IDestroyOptions, Sprite, Text, TextStyle, Texture } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { StringFormatExtention } from "../../../../../extensions/StringFormatExtention";

export class CardCostContainer extends Container {
    protected costContainer: Container;
    private icon: Sprite;
    protected costText: Text;

    public constructor(value: number, iconTexture: Texture) {
        super();
        this.costContainer = new Container();
        this.costText = new Text(StringFormatExtention.formatWithComma(value), new CostTextStyle());
        this.costText.anchor.set(0.5, 0.5);
        this.costContainer.addChild(this.costText);
        this.icon = new Sprite(iconTexture);
        this.icon.anchor.set(0.5, 0.5);
        this.icon.scale.set(0.6);
        this.icon.x = this.costText.width * 0.5 + this.icon.width * 0.6;
        this.costContainer.addChild(this.icon);
        this.costContainer.x = this.costText.width * 0.5 - this.costContainer.width * 0.5;
        this.addChild(this.costContainer);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        super.destroy(options);
    }
}

class CostTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#000000",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 54
        }));
    }
}
